import { Injectable } from '@angular/core'
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Rx'

import { MenuItemService } from './shared/'

@Injectable()
export class MenuItemResolver implements Resolve<any> {
  constructor(private _menuItemService: MenuItemService) {}

  public resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<any> {
    return this._menuItemService.findAllModels(['menuItems.menuItems.menuItems'])
  }
}



// WEBPACK FOOTER //
// ./src/app/menu-item.resolver.ts